// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2665) return "static/chunks/2665-512100ff0562e5c3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4989":"865a48b68835f313","8208":"d90a0cbf6b584d12"}[chunkId] + ".js";
};